import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import newSection from '@/payloads/section.json';
import newPage from '@/payloads/page.json';
import { siteBuilder } from '@/mixins/site-builder';
import dropsLoader from '@/mixins/components/drops-loader';

export default Vue.component('add-template', {
  template: require('./template.html'),
  mixins: [siteBuilder],
  components: {
    dropsLoader,
  },
  computed: {
    ...mapGetters([
      'currentPage',
      'currentSite',
      'initialCurrentPage',
    ]),
    savedTemplates() {
      return _.map(this._currentSite.templates, 'name');
    },
  },
  props: [
    'toggle-modal',
    'unsavedChanges',
    'change-unsaved',
  ],
  data() {
    return {
      templatename: '',
      tplNameCheckError: false,
      loading: false,
    };
  },
  methods: {
    async save() {
      // run front end validation
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.tplNameCheck(this.templatename).then((noDuplicates) => {
            if (noDuplicates) {
              // first check if there are any unsaved changes to the current page
              if (_.isEqual(this.currentPage, this.initialCurrentPage)) {
                // proceed with new page
                this.goToNew();
              } else {
                // unsaved changes present
                this.$emit('change-unsaved', true);
              }
            }
          });
        }
      });
    },
    async goToNew() {
      this.$emit('toggle-modal');
      // prepare the empty template with new values
      const template = _.cloneDeep(newPage);
      template._id = this.guid();
      template.createdDate = new Date().toISOString();
      template.name = this.templatename;
      template.type = 'template';
      if (!this._published) {
        // we only set published templates brand new so that users
        // can attach them to pages during the build phase.
        template.status = 'published';
      }
      const section = _.cloneDeep(newSection);
      section._id = this.guid();
      section.createdDate = new Date().toISOString();
      section.templateRegion = true;
      template.blocks = [section];

      // prep notification
      let type = 'success';
      let message = `New template: ${template.name} created!`;
      try {
        // save all data to db
        await this.$lightning([{
          name: 'addPageItem',
          payload: {
            siteId: this.currentSite._id,
            item: template,
          },
        }]);
        // add page to page type array in state
        this.$store.dispatch('addTemplate', template);
        this.$store.dispatch('setOriginalPage', template);
        await this.$store.dispatch('setCurrentPage', template);
      } catch (e) {
        this.$log.error('error: ', e);
        type = 'error';
        message = `${e.message || e}. This has been reported.`;
        await this._reportError({
          error: e,
          fn: 'goToNew',
        });
      } finally {
        this.$store.dispatch('addNotification', {
          id: this.guid(),
          type,
          message,
        });
        this._trackEvent({
          type: 'add_template',
          meta: {
            site_type: this.currentSite.type,
            site_tier: this.currentSite.tier,
            site_name: this.currentSite.alias,
            page_name: this.templatename,
          },
        });
      }
    },
    async checkPage(choice) {
      if (choice === 'yes') {
        const isDroplet = !this._pageTypes.includes(this.currentPage.type);
        if (!isDroplet) {
          // revert the droplet count to the initial value
          await this.$store.dispatch('revertDropletCounts', {
            site: this.currentSite,
          });
          // revert all page data to the initial value
          await this.$store.dispatch('revertPage', this.initialCurrentPage);
        } else {
          // this will revert a droplet to when it was loaded
          const index = _.findIndex(this.currentSite.recycled, r => r._id === this.currentPage._id);
          const $vm = this;
          this.$store.dispatch('runStateFn', {
            fn() {
              $vm.currentSite.recycled.splice(index, 1, $vm.initialCurrentPage);
            },
          });
        }
        this.$store.dispatch('updateInitialPage');
        this.goToNew();
      }
      if (choice === 'no') {
        this.$emit('toggle-modal');
      }
    },
    nameCheck(e) {
      let val = e.currentTarget.value;
      val = val.replace(/[^a-zA-Z0-9|\s]/g, '-');
      this.templatename = val;
    },
    tplNameCheck(name) {
      // check all pages for this site
      const valid = this.savedTemplates.includes(name);
      if (valid) {
        this.tplNameCheckError = 'There is another template with that name, please try another.';
      } else {
        this.tplNameCheckError = false;
      }
      return new Promise((resolve) => {
        resolve(!valid);
      });
    },
    clearAll() {
      this.templatename = '';
    },
    cancel() {
      this.$emit('toggle-modal');
    },
    formatErrors(ers) {
      let string = '';
      _.forEach(ers, (er) => {
        string = string += ` ${er}`;
      });
      return string;
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/page/top-control-bar/add-template/index.js